import { BellRing, CalendarClock, CalendarPlus, UserRound } from "lucide-react";
import { Button } from "@/components/ui/button";
import { SERVICE_TYPES, formatDate } from "@/lib/services";
import { useServices } from "@/context/ServicesContext";
import { WhatsAppButton } from "@/components/app/WhatsAppButton";

const Small = ({ icon: Icon, label, onClick, testid, cls = "" }) => (
  <Button size="sm" variant="outline" onClick={onClick} className={`h-8 rounded-full border-slate-700 bg-transparent px-3 text-xs ${cls}`} data-testid={testid}>
    <Icon className="mr-1 h-3.5 w-3.5" /> {label}
  </Button>
);

export const ArchivedItem = ({ s, onAct }) => {
  const { openClient } = useServices();
  const t = SERVICE_TYPES[s.service_type];
  return (
    <li className={`rounded-xl border p-4 ${s.reminder_due ? "border-amber-400/70 bg-amber-500/[0.10]" : "border-slate-700/60 bg-slate-800/60"}`}
      style={{ borderLeft: `3px solid ${t?.hex || "#94A3B8"}` }} data-testid={`archived-item-${s.id}`}>
      <div className="flex flex-wrap items-start justify-between gap-2">
        <div className="min-w-0">
          <button onClick={() => openClient(s.client_name)} className="truncate text-left font-semibold hover:underline" data-testid={`archived-client-${s.id}`}>{s.client_name}</button>
          <div className="text-xs text-slate-400">{s.service_name} · previsto para <span className="font-mono">{formatDate(s.execution_date)}</span></div>
          <div className="mt-1 text-xs text-slate-400">{[s.contact_person, s.phone, s.email].filter(Boolean).join(" · ") || "Sem telefone e e-mail"}</div>
          <div className="mt-1 text-xs text-slate-500">Arquivado em {formatDate(s.archived_at?.slice(0, 10))}</div>
          {s.archive_note && <div className="text-xs italic text-slate-400">“{s.archive_note}”</div>}
        </div>
        {s.remind_on && (
          <span className={`rounded-full border px-2 py-0.5 text-[11px] font-semibold ${s.reminder_due ? "border-amber-300 bg-amber-400 text-amber-950" : "border-slate-600 text-slate-300"}`} data-testid={`archived-reminder-${s.id}`}>
            <BellRing className="mr-1 inline h-3 w-3" />{s.reminder_due ? "Tentar de novo agora" : `Lembrete ${formatDate(s.remind_on)}`}
          </span>
        )}
      </div>
      <div className="mt-3 flex flex-wrap gap-2">
        <WhatsAppButton phone={s.phone} who={s.contact_person || s.client_name} testid={`archived-whatsapp-${s.id}`} />
        <Small icon={UserRound} label="Ficha" onClick={() => openClient(s.client_name)} testid={`archived-open-client-${s.id}`} />
        <Small icon={CalendarPlus} label="Reagendar" onClick={() => onAct(s, "reschedule")} testid={`archived-reschedule-${s.id}`} cls="text-emerald-300" />
        <Small icon={CalendarClock} label="Lembrar em" onClick={() => onAct(s, "remind")} testid={`archived-remind-${s.id}`} cls="text-amber-300" />
      </div>
    </li>
  );
};
